import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { useTranslation } from "react-i18next";
import { gettotalOffers } from "../../store/totaloffer/totaloffAction";
import Loader from "../../component/Loader";
import bg from "../../assets/pexels-tara-winstead-8386713.jpg";

import img1 from "../../assets/main/1.jpg";
import img2 from "../../assets/main/2.jpg";
import img3 from "../../assets/main/3.jpg";
import img4 from "../../assets/main/4.jpg";
import img5 from "../../assets/main/5.jpg";
import img6 from "../../assets/main/6.jpg";
const MainBlog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lan = useSelector((state) => state.LanSlicer.language);
  const { offers, loading } = useSelector((state) => state.Offers);

  return (
    <Fragment>
      <section
        class="flat-title-page back-ground-style"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="breadcrumbs text-center link-style-5 text-white">
              <h2 class="section-title-page">Blog</h2>
              <ul class="breadcrumbs-inner list-center display-flex">
                <li>
                  <Link class="section-16px-regular font-weight-500" to={"/"}>
                    Home
                  </Link>
                </li>
                <li>
                  <h4 class="section-16px-regular font-weight-500">Blog</h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="flat-blog">
        <div class="container">
          <div class="row">
            <div class="col-md-8">
              <article class="main-post-box">
                <div class="featured-post">
                  <div class="entry-image">
                    <img src={img1} alt="images" />
                  </div>
                </div>
                <div class="post-content">
                  <ul class="post-meta">
                    <li class="author">
                      <Link to={"/singleBlog"}>Ranvir Sing</Link>
                    </li>
                    <li class="date">
                      <Link to={"/singleBlog"}>15 Jun, 2021</Link>
                    </li>
                    <li class="comment">0 Comments</li>
                  </ul>
                  <Link to={"/singleBlog"} class="section-24px-montserrat">
                    Providing Professional or Expert Advice
                  </Link>
                  <p>
                    Consulting is defined as the practise of providing a third
                    party with etise on matter in exchange for a fee. The
                    service may involve either advisory or implementation
                    services. For the consultant, taking an independen
                  </p>
                </div>
              </article>
              <article class="main-post-box">
                <div class="featured-post">
                  <div class="entry-image">
                    <img src={img2} alt="images" />
                  </div>
                </div>
                <div class="post-content">
                  <ul class="post-meta">
                    <li class="author">
                      <Link to={"/singleBlog"}>Ranvir Sing</Link>
                    </li>
                    <li class="date">
                      <Link to={"/singleBlog"}>15 Jun, 2021</Link>
                    </li>
                    <li class="comment">0 Comments</li>
                  </ul>
                  <Link to={"/singleBlog"} class="section-24px-montserrat">
                    Software Database Great Video example
                  </Link>
                  <p>
                    Consulting is defined as the practise of providing a third
                    party with etise on matter in exchange for a fee. The
                    service may involve either advisory or implementation
                    services. For the consultant, taking an independen
                  </p>
                </div>
              </article>
              <article class="main-post-box">
                <div class="featured-post">
                  <div class="entry-image">
                    <img src={img3} alt="images" />
                  </div>
                </div>
                <div class="post-content">
                  <ul class="post-meta">
                    <li class="author">
                      <Link to={"/singleBlog"}>Ranvir Sing</Link>
                    </li>
                    <li class="date">
                      <Link to={"/singleBlog"}>15 Jun, 2021</Link>
                    </li>
                    <li class="comment">0 Comments</li>
                  </ul>
                  <Link to={"/singleBlog"} class="section-24px-montserrat">
                    thumbHow to be appreciated for your hard work as
                  </Link>
                  <p>
                    Consulting is defined as the practise of providing a third
                    party with etise on matter in exchange for a fee. The
                    service may involve either advisory or implementation
                    services. For the consultant, taking an independen
                  </p>
                </div>
              </article>
              <article class="main-post-box">
                <div class="featured-post">
                  <div class="entry-image">
                    <img src={img4} alt="images" />
                  </div>
                </div>
                <div class="post-content">
                  <ul class="post-meta">
                    <li class="author">
                      <Link to={"/singleBlog"}>Ranvir Sing</Link>
                    </li>
                    <li class="date">
                      <Link to={"/singleBlog"}>15 Jun, 2021</Link>
                    </li>
                    <li class="comment">0 Comments</li>
                  </ul>
                  <Link to={"/singleBlog"} class="section-24px-montserrat">
                    How designers and developers can collaborate better
                  </Link>
                  <p>
                    Consulting is defined as the practise of providing a third
                    party with etise on matter in exchange for a fee. The
                    service may involve either advisory or implementation
                    services. For the consultant, taking an independen
                  </p>
                </div>
              </article>
              <div class="themesflat-pagination clearfix">
                <ul>
                  <li>
                    <Link href="#" class="prev margin-right-10">
                      PREV
                    </Link>
                  </li>
                  <li>
                    <Link href="#" class="page-numbers">
                      01
                    </Link>
                  </li>
                  <li>
                    <Link href="#" class="page-numbers">
                      02
                    </Link>
                  </li>
                  <li>
                    <Link href="#" class="page-numbers current">
                      03
                    </Link>
                  </li>
                  <li>
                    <Link href="#" class="page-numbers">
                      04
                    </Link>
                  </li>
                  <li>
                    <Link href="#" class="page-numbers">
                      05
                    </Link>
                  </li>
                  <li>
                    <Link href="#" class="next margin-left-10">
                      NEXT
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-4">
              <div class="side-bar">
                <div class="widget-search-box">
                  <h2 class="widget-title section-22px-montserrat margin-bottom-38">
                    Search
                  </h2>
                  <div class="widget-search">
                    <form
                      action="#"
                      method="get"
                      role="search"
                      class="search-form"
                    >
                      <input
                        type="search"
                        class="search-field"
                        placeholder="Search..."
                        value=""
                        name="s"
                        title="Search for"
                        required
                      />
                      <button
                        class="search-submit"
                        type="submit"
                        title="Search"
                      ></button>
                    </form>
                  </div>
                </div>
                <div class="widget-popular-post">
                  <h2 class="widget-title section-22px-montserrat margin-bottom-38">
                    Popular post
                  </h2>
                  <div class="widget-popular-post-inner display-flex">
                    <ul class="widget-post-item margin-bottom-5">
                      <li>
                        <div class="thumb-image border-radius-4 margin-bottom-17">
                          <img src={img4} alt="images" />
                        </div>
                        <div class="thumb-content">
                          <Link
                            to={"/singleBlog"}
                            class="section-16px-regular font-weight-500 line-height-25"
                          >
                            Terrorism concerns get & tourists
                          </Link>
                          <br />
                          <Link
                            to={"/singleBlog"}
                            class="date section-14px-regular"
                          >
                            15 Jun, 2021{" "}
                          </Link>
                        </div>
                      </li>
                      <li>
                        <div class="thumb-image border-radius-4 margin-bottom-17">
                          <img src={img5} alt="images" />
                        </div>
                        <div class="thumb-content">
                          <Link
                            to={"/singleBlog"}
                            class="section-16px-regular font-weight-500 line-height-25"
                          >
                            Curfew imposed after mosques attacked
                          </Link>
                          <br />
                          <Link
                            to={"/singleBlog"}
                            class="date section-14px-regular"
                          >
                            15 Jun, 2021{" "}
                          </Link>
                        </div>
                      </li>
                      <li>
                        <div class="thumb-image border-radius-4 margin-bottom-17">
                          <img src={img6} alt="images" />
                        </div>
                        <div class="thumb-content">
                          <Link
                            to={"/singleBlog"}
                            class="section-16px-regular font-weight-500 line-height-25"
                          >
                            Young afghan ampu tee joy at dancing
                          </Link>
                          <br />
                          <Link
                            to={"/singleBlog"}
                            class="date section-14px-regular"
                          >
                            15 Jun, 2021{" "}
                          </Link>
                        </div>
                      </li>
                      <li>
                        <div class="thumb-image border-radius-4 margin-bottom-17">
                          <img src={img6} alt="images" />
                        </div>
                        <div class="thumb-content">
                          <Link
                            to={"/singleBlog"}
                            class="section-16px-regular font-weight-500 line-height-25"
                          >
                            Fizz headlines strong showing
                          </Link>
                          <br />
                          <Link
                            to={"/singleBlog"}
                            class="date section-14px-regular"
                          >
                            15 Jun, 2021{" "}
                          </Link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="widget-socials-media">
                  <h2 class="widget-title section-22px-montserrat margin-bottom-52">
                    Follow us
                  </h2>
                  <ul class="widget-socials-media-item">
                    <li>
                      <Link
                        href="#"
                        class="icon-socials icon-facebook-app-logo1"
                      ></Link>
                    </li>
                    <li>
                      <Link href="#" class="icon-socials icon-twitter1"></Link>
                    </li>
                    <li>
                      <Link
                        href="#"
                        class="icon-socials icon-linkedin-11"
                      ></Link>
                    </li>
                    <li>
                      <Link
                        href="#"
                        class="icon-socials icon-instagram1"
                      ></Link>
                    </li>
                    <li>
                      <Link href="#" class="icon-socials icon-youtube1"></Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default MainBlog;
